import type { ReactNode } from 'react';

interface EmptyStateProps {
  title: string;
  description?: string;
  action?: ReactNode;
  /** Icono decorativo opcional (un emoji o un caracter). */
  icon?: string;
}

export function EmptyState({
  title,
  description,
  action,
  icon = '◎',
}: EmptyStateProps): JSX.Element {
  return (
    <div className="empty">
      <span className="empty__icon" aria-hidden="true">
        {icon}
      </span>
      <p className="empty__title">{title}</p>
      {description && <p className="empty__text">{description}</p>}
      {action && <div className="empty__action">{action}</div>}
    </div>
  );
}

export function LoadingState({ label = 'Cargando…' }: { label?: string }): JSX.Element {
  return (
    <div className="loading" role="status" aria-live="polite">
      <span className="loading__spinner" aria-hidden="true" />
      <span>{label}</span>
    </div>
  );
}

export function ErrorState({
  message,
  onRetry,
}: {
  message: string;
  onRetry?: () => void;
}): JSX.Element {
  return (
    <div className="empty empty--error" role="alert">
      <span className="empty__icon" aria-hidden="true">
        !
      </span>
      <p className="empty__title">No hemos podido cargar los datos</p>
      <p className="empty__text">{message}</p>
      {onRetry && (
        <div className="empty__action">
          <button type="button" className="btn btn--ghost" onClick={onRetry}>
            Reintentar
          </button>
        </div>
      )}
    </div>
  );
}
